import isNil from 'lodash/isNil';

export enum ConvertibleOrderType {
  Market = 'Market',
  WideEnd = 'Wide-End',
  MidPoint = 'Mid-Point',
  TightEnd = 'Tight-End',
  Custom = 'Custom',
}

export type GetConvertibleOrderTypeParams = {
  coupon: number | null;
  premium: number | null;
  percentageOfPar: number | null;
  isIndicationPriceAsPercentageParEnabled: boolean;
  couponTalkLow: number | null;
  couponTalkHigh: number | null;
  premiumTalkLow: number | null;
  premiumTalkHigh: number | null;
  priceAsOfPar: number;
};

export function getConvertibleOrderType({
  coupon,
  premium,
  percentageOfPar,
  isIndicationPriceAsPercentageParEnabled,
  couponTalkLow,
  couponTalkHigh,
  premiumTalkLow,
  premiumTalkHigh,
  priceAsOfPar,
}: GetConvertibleOrderTypeParams) {
  if (isNil(coupon) && isNil(premium) && isNil(percentageOfPar)) {
    return ConvertibleOrderType.Market;
  }

  if (
    isNil(couponTalkLow) ||
    isNil(couponTalkHigh) ||
    isNil(premiumTalkLow) ||
    isNil(premiumTalkHigh)
  ) {
    return ConvertibleOrderType.Custom;
  }

  const orderTypeConfigurations = getConvertibleOrderTypeConfiguration({
    couponTalkLow,
    couponTalkHigh,
    premiumTalkLow,
    premiumTalkHigh,
    priceAsOfPar,
  });

  const configurationsMatchingPercentageOfPar = isIndicationPriceAsPercentageParEnabled
    ? percentageOfPar === 1 || percentageOfPar === null
    : true;

  if (
    coupon === orderTypeConfigurations[ConvertibleOrderType.TightEnd].coupon &&
    premium === orderTypeConfigurations[ConvertibleOrderType.TightEnd].premium &&
    configurationsMatchingPercentageOfPar
  ) {
    return ConvertibleOrderType.TightEnd;
  }

  if (
    coupon === orderTypeConfigurations[ConvertibleOrderType.WideEnd].coupon &&
    premium === orderTypeConfigurations[ConvertibleOrderType.WideEnd].premium &&
    configurationsMatchingPercentageOfPar
  ) {
    return ConvertibleOrderType.WideEnd;
  }

  if (
    coupon === orderTypeConfigurations[ConvertibleOrderType.MidPoint].coupon &&
    premium === orderTypeConfigurations[ConvertibleOrderType.MidPoint].premium &&
    configurationsMatchingPercentageOfPar
  ) {
    return ConvertibleOrderType.MidPoint;
  }

  return ConvertibleOrderType.Custom;
}

type GetConvertibleOrderTypeConfigurationParams = {
  couponTalkLow: number;
  couponTalkHigh: number;
  premiumTalkLow: number;
  premiumTalkHigh: number;
  priceAsOfPar: number;
};

export function getConvertibleOrderTypeConfiguration({
  couponTalkLow,
  couponTalkHigh,
  premiumTalkLow,
  premiumTalkHigh,
  priceAsOfPar,
}: GetConvertibleOrderTypeConfigurationParams) {
  return {
    [ConvertibleOrderType.TightEnd]: {
      coupon: couponTalkLow,
      premium: premiumTalkHigh,
      priceAsOfPar,
    },
    [ConvertibleOrderType.WideEnd]: {
      coupon: couponTalkHigh,
      premium: premiumTalkLow,
      priceAsOfPar,
    },
    [ConvertibleOrderType.MidPoint]: {
      coupon: +((couponTalkLow + couponTalkHigh) / 2).toFixed(6),
      premium: +((premiumTalkLow + premiumTalkHigh) / 2).toFixed(4),
      priceAsOfPar,
    },
  };
}
